<h1 mat-dialog-title> Your session is about to expire! </h1>
<mat-dialog-content>

	<div class="zoom-text-session padding">
		For your safety and protection, your session is about to be timed out if there is no additional activity. If you
		are still working, simply click the "Extend Session" button to continue working. Any unsaved changes will be lost.
	</div>

	<ng-container>
		<div class="zoom-text-session padding-top">
			You will be timed out in <strong> {{ minutesLeft }} minute(s)</strong>
			<p>
				<mat-progress-bar class="audio-progress-bar wrapper " mode="determinate"
					[value]="sessionExpireProgress"></mat-progress-bar>
			</p>
		</div>
	</ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<div class="is-taller">
		<div class="level">
			<div class="level-item">
				<button class="bofa--button secondary" type="button" (click)="extendSession()">Extend Session</button>
			</div>

			<div class="level-item">
				<button class="bofa--button secondary outlined" type="button" (click)="onNoClick()">Logout</button>
			</div>
		</div>
	</div>
</mat-dialog-actions>